import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { SessionContext, SessionContextType } from '../../../app/contexts/SessionContext';
import { useDocumentTitle } from '../../../app/hooks/use-document-title';
import { FacilitiesList } from './FacilitiesList';

export const HealthcareEntityFacilitiesList = () => {
  useDocumentTitle('Facilities List');
  const { user } = useContext<SessionContextType>(SessionContext);
  const canEditFacility = Boolean(user?.group_names?.includes('manage_facilities'));

  return (
    <>
      <div className="bg-primary-dark">
        <Container className="page-header-title">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="mb-3">Facilities</h1>
          </div>
        </Container>
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="bg-primary-dark d-block"
          style={{
            height: '60px',
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            zIndex: -10,
          }}
        />
        <Container style={{ position: 'relative' }}>
          <Row className="justify-content-center" xs={12}>
            <Col>
              <FacilitiesList showAddFacilityButton={canEditFacility} />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
